import { styled } from '@mui/material/styles'

export const MenuWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`
